var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { FolgeverordnungReason } from '../folgeverordnung-context.js';
/**
 * An exhausted or expiring treatment plan whose card offers a Folgeverordnung
 * (PRD #1343, RS-011). Instead of dead-ending, the patient scans a NEW
 * Verordnung (or types it) and books ONE hold anchored to this episode's
 * continuity therapist + Kombi grouping. Deliberately minimal and
 * record-independent (the iframe surface renders it unchanged): the plan's
 * Heilmittel label, the continuity therapist's display name, and why it
 * surfaced — nothing else. Redaction (fixed decision #12) holds: no therapist
 * id, no scheduling internals.
 */
export class PatientFolgeverordnungPlanDto {
    /** The predecessor plan the new episode continues (carried on the hold at booking). */
    predecessorPlanId;
    /** The plan's Heilmittel names joined (e.g. "Krankengymnastik + Manuelle Therapie"). */
    treatmentLabel;
    /** The established (continuity) therapist's display name. */
    therapistName;
    /** Why the card surfaced — exhausted allowance or nearing expiry. */
    reason;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientFolgeverordnungPlanDto.prototype, "predecessorPlanId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientFolgeverordnungPlanDto.prototype, "treatmentLabel", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientFolgeverordnungPlanDto.prototype, "therapistName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientFolgeverordnungPlanDto.prototype, "reason", void 0);
//# sourceMappingURL=patient-folgeverordnung-plan.dto.js.map